import React from 'react';
import { QuoteIcon } from 'lucide-react';
import type { SampleReview } from '../../../data/christmasReviews';
export function SampleReviewCard({
  review
}: {
  review: SampleReview;
}) {
  return <div className="flex h-full flex-col rounded-[2rem] bg-cream p-8 ring-1 ring-[#E3C77F]/50 sm:p-10" data-id="element-304" data-mp="o739xd2vseap">
      <div className="flex items-start justify-between gap-4" data-id="element-305" data-mp="j78j19j3vopn">
        <QuoteIcon className="h-9 w-9 text-[#E3C77F]" aria-hidden="true" data-id="element-306" data-mp="j5nqtqk9khuy" />
        <span className="rounded-full bg-white px-3 py-1 text-[11px] font-bold uppercase tracking-[0.14em] text-olive ring-1 ring-[#E3C77F]/60" data-id="element-307" data-mp="3rnjumhod58d1">
          Sample Review
        </span>
      </div>
      <h3 className="mt-6 font-display text-2xl font-medium text-forest" data-id="element-308" data-mp="59a9qijn6ih0">{review.title}</h3>
      <blockquote className="mt-3 flex-1 font-display text-xl leading-relaxed text-forest/80 sm:text-[1.35rem]" data-id="element-309" data-mp="ffr7ifrw9ji">
        “{review.text}”
      </blockquote>
      <div className="mt-8 border-t border-forest/10 pt-5" data-id="element-310" data-mp="33xzc1zw4gd4a">
        <div className="flex items-center gap-3" data-id="element-311" data-mp="33vmuhnua04rr">
          <img src={review.avatar} alt={`Sample avatar for ${review.displayName}`} width={48} height={48} className="h-12 w-12 shrink-0 rounded-full object-cover object-center ring-2 ring-[#E3C77F]/70" data-id="element-312" data-mp="ib7tcem7e3cq" />
          <p className="font-semibold text-forest" data-id="element-313" data-mp="wzcavf9is8tx">{review.displayName}</p>
        </div>
        <p className="mt-4 text-xs text-forest/50" data-id="element-314" data-mp="x159q8dw5ord">
          Sample content for preview purposes — not a customer testimonial.
        </p>
      </div>
    </div>;
}